import React from 'react';
import { GetStaticProps } from 'next';
import { NewsPageId } from '../../../../../features/app/pages/domain/constants/PageId';
import { getEnrichedPageById } from '../../../../../features/app/pages/domain/use-cases/getEnrichedPageById';
import { getStaticPathsForPagination } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForPagination';
import { defaultLocale } from '../../../../../features/shared/i18n/locale/constants/default';
import { getLocaleFromPath } from '../../../../../features/shared/i18n/locale/getLocaleFromPath';
import { IBlogsPageData } from '../../../../../features/news/domain/models/IBlogsPageData';
import { BlogsPage } from '../../../../../features/news/ui/BlogsPage';
import {
	getAllBlogItems,
	getBlogItemsTotalCount,
} from '../../../../../features/news/domain/use-cases/blog-item';
import { getContentCategoriesTitles } from '../../../../../features/shared/domain/utils/getContentCategories';

const DEFAULT_PAGE_NUMBER = 1;
const ITEMS_PER_PAGE = 10;

const Page = ({
	page,
	blogs,
	pageNumber,
	categoriesFilter,
}: IBlogsPageData) => (
	<BlogsPage
		page={page}
		blogs={blogs}
		pageNumber={pageNumber}
		itemsPerPage={ITEMS_PER_PAGE}
		categoriesFilter={categoriesFilter}
	/>
);

export const getStaticPaths = async () =>
	getStaticPathsForPagination(getBlogItemsTotalCount, ITEMS_PER_PAGE);

export const getStaticProps: GetStaticProps = async ({ params }) => {
	const locale = getLocaleFromPath(params?.locale ?? '') ?? defaultLocale;
	const paramPageNumber = Number.parseInt(params?.pageNumber as string, 10);
	const pageNumber = paramPageNumber || DEFAULT_PAGE_NUMBER;

	const [page, blogs, contentCategories] = await Promise.all([
		getEnrichedPageById(NewsPageId.Blogs, locale),
		getAllBlogItems(locale),
		getContentCategoriesTitles('Blog', locale),
	]);

	if (!page) {
		return {
			notFound: true,
		};
	}

	const categoriesFilter = contentCategories.filter(Boolean).sort() ?? null;

	return {
		props: {
			page,
			blogs,
			pageNumber,
			categoriesFilter,
		},
	};
};

export default Page;
